import { qyllbPostOrder, qyllbLogin } from '@/api/qyllb'
import { Toast } from 'vant'

let initState = {
  appLet: {
    unionId: '',
    openId: '',
    appId: '',
  },

  isTTMini: false,
}

let cloneDeep = (data) => {
  //copy一份数据
  return JSON.parse(JSON.stringify(data))
}
const state = cloneDeep(initState)
const mutations = {
  SET_APPLET: (state, data) => {
    state.appLet = data
  },
  SET_APPLET: (state, data) => {
    state.appLet = data
  },
  SET_ISTTMINI: (state, data) => {
    state.isTTMini = data
  },
  INIT_STATE: (state) => {
    Object.assign(state, initState)
  },
}
const actions = {
  initState({ commit }) {
    commit(`INIT_STATE`)
  },
  setIsTTMini({ commit, state }, data) {
    commit(`SET_ISTTMINI`, data)
  },
  setAppLet({ commit }, data) {
    commit(`SET_APPLET`, data)
  },
  getAppLet({ dispatch, state, rootState }, formData) {
    console.log(`我进来这里了吗`, state)
    if (state.isTTMini) {
      return { appLet: { ...state.appLet, img: rootState.public.selectCard.top_image_url }, ...formData }
    } else {
      return formData
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
